<template>
  <form method="post" class="calc-form" @submit.prevent="handleSubmit">
    <!-- calc-amount -->
    <div class="calc-form__row">
      <label class="calc-form__label" for="calc-amount">Сколько рекрутеров работает в&nbsp;вашей компании?</label>
      <div class="calc-form__inputs">
        <!-- Вешаю обработчик input таким образом, потому что если функцию использовать через вью компонент, она работает некорректно: дает вводить буквы после удаления всех символов из поля и при копипасте -->
        <input
          id="calc-amount"
          class="calc-form__input-text"
          v-model.number="form.amount"
          min="0"
          maxlength="3"
          type="text"
          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
          @blur="replaceEmptyValue(form.amount, 'amount')"
        />

        <div class="calc-form__range">
          <input
            v-model.number="form.amount"
            :class="{ 'calc-form__range-input--hidden-thumb': hideThumb(form.amount) }"
            class="calc-form__range-input"
            type="range"
            min="1"
            step="1"
            max="50"
          />
          <div class="calc-form__range-progress" :style="{ width: updateProgressBarWidth(form.amount, 1, 50) }"></div>
        </div>
      </div>
    </div>
    <!-- calc-salary -->
    <div class="calc-form__row">
      <label class="calc-form__label" for="calc-salary">Сколько один рекрутер получает в&nbsp;месяц?</label>
      <div class="calc-form__inputs">
        <input
          id="calc-salary"
          class="calc-form__input-text"
          :value="formatedSalary"
          min="0"
          maxlength="6"
          type="text"
          @focus="removeRubleSign"
          @input="handleSalaryInput"
          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
          @blur="formatSalaryOnBlur"
        />

        <span class="calc-form__error" v-if="form.salary === 0">Введены некорректные значения</span>

        <div class="calc-form__range">
          <input
            v-model.number="form.salary"
            class="calc-form__range-input"
            :class="{ 'calc-form__range-input--hidden-thumb': hideThumb(form.salary) }"
            type="range"
            min="1000"
            step="1000"
            max="300000"
            @input="updateFormattedSalary"
          />

          <div
            class="calc-form__range-progress"
            :style="{ width: updateProgressBarWidth(form.salary, 1, 300000) }"
          ></div>
        </div>
      </div>
    </div>
    <!-- calc-resume_per_day -->
    <div class="calc-form__row">
      <label class="calc-form__label" for="calc-resume_per_day"
        >Сколько резюме в&nbsp;день сохраняет один рекрутер?</label
      >
      <div class="calc-form__inputs">
        <input
          id="calc-resume_per_day"
          class="calc-form__input-text"
          v-model.number="form.params.resume_per_day"
          min="0"
          maxlength="3"
          type="text"
          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
          @blur="replaceEmptyValue(form.params.resume_per_day, 'params.resume_per_day')"
        />

        <div class="calc-form__range">
          <input
            v-model.number="form.params.resume_per_day"
            :class="{ 'calc-form__range-input--hidden-thumb': hideThumb(form.params.resume_per_day) }"
            class="calc-form__range-input"
            type="range"
            min="1"
            step="1"
            max="50"
          />
          <div
            class="calc-form__range-progress"
            :style="{ width: updateProgressBarWidth(form.params.resume_per_day, 1, 50) }"
          ></div>
        </div>
      </div>
    </div>
    <!-- calc-mail_per_day -->
    <div class="calc-form__row">
      <label class="calc-form__label" for="calc-mail_per_day"
        >Сколько резюме в&nbsp;день отправляет заказчикам один рекрутер?</label
      >
      <div class="calc-form__inputs">
        <input
          id="calc-mail_per_day"
          class="calc-form__input-text"
          v-model.number="form.params.mail_per_day"
          min="0"
          maxlength="3"
          type="text"
          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
          @blur="replaceEmptyValue(form.params.mail_per_day, 'params.mail_per_day')"
        />

        <div class="calc-form__range">
          <input
            v-model.number="form.params.mail_per_day"
            :class="{ 'calc-form__range-input--hidden-thumb': hideThumb(form.params.mail_per_day) }"
            class="calc-form__range-input"
            type="range"
            min="0"
            step="1"
            max="30"
          />
          <div
            class="calc-form__range-progress"
            :style="{ width: updateProgressBarWidth(form.params.mail_per_day, 0, 30) }"
          ></div>
        </div>
      </div>
    </div>
    <!-- calc-cal_per_day -->
    <div class="calc-form__row">
      <label class="calc-form__label" for="calc-cal_per_day"
        >Сколько интервью в&nbsp;день назначает один рекрутер?</label
      >
      <div class="calc-form__inputs">
        <input
          id="calc-cal_per_day"
          class="calc-form__input-text"
          v-model.number="form.params.cal_per_day"
          min="0"
          maxlength="3"
          type="text"
          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
          @blur="replaceEmptyValue(form.params.cal_per_day, 'params.cal_per_day')"
        />

        <div class="calc-form__range">
          <input
            v-model.number="form.params.cal_per_day"
            :class="{ 'calc-form__range-input--hidden-thumb': hideThumb(form.params.cal_per_day) }"
            class="calc-form__range-input"
            type="range"
            min="0"
            step="1"
            max="30"
          />

          <div
            class="calc-form__range-progress"
            :style="{ width: updateProgressBarWidth(form.params.cal_per_day, 0, 30) }"
          ></div>
        </div>
      </div>
    </div>
    <!-- calc-mail_tpl_per_day -->
    <div class="calc-form__row">
      <label class="calc-form__label" for="calc-mail_tpl_per_day">
        Сколько первичных писем и&nbsp;сообщений кандидатам в&nbsp;день отправляет один рекрутер?
      </label>
      <div class="calc-form__inputs">
        <input
          id="calc-mail_tpl_per_day"
          class="calc-form__input-text"
          v-model.number="form.params.mail_tpl_per_day"
          min="0"
          maxlength="3"
          type="text"
          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
          @blur="replaceEmptyValue(form.params.mail_tpl_per_day, 'params.mail_tpl_per_day')"
        />

        <div class="calc-form__range">
          <input
            v-model.number="form.params.mail_tpl_per_day"
            :class="{ 'calc-form__range-input--hidden-thumb': hideThumb(form.params.mail_tpl_per_day) }"
            class="calc-form__range-input"
            type="range"
            min="0"
            step="1"
            max="50"
          />
          <div
            class="calc-form__range-progress"
            :style="{ width: updateProgressBarWidth(form.params.mail_tpl_per_day, 0, 50) }"
          ></div>
        </div>
      </div>
    </div>

    <button class="button calc-form__button button--primary">Рассчитать экономию</button>
  </form>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'ParamsForm',
  data() {
    return {
      formatedSalary: 0,
      defaultFormParams: cloneDeep(this.defaultParams),
    };
  },
  props: {
    defaultParams: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.updateFormattedSalary();
  },
  methods: {
    handleSalaryInput(event) {
      const value = event.target.value;
      this.formatedSalary = value;
      this.form.salary = value;
    },
    updateFormattedSalary() {
      this.formatedSalary = Intl.NumberFormat('ru-RU').format(this.form.salary) + ' ₽';
    },
    removeRubleSign() {
      this.formatedSalary = this.form.salary;
    },
    hideThumb(value) {
      return value === '';
    },
    replaceEmptyValue(value, fieldName) {
      const isParamsField = fieldName.includes('params');
      const key = isParamsField ? fieldName.split('.')[1] : fieldName;
      const defaultValue = isParamsField ? this.defaultFormParams.params[key] : this.defaultFormParams[fieldName];

      if (value === '') {
        if (isParamsField) {
          this.form.params[key] = defaultValue;
        } else {
          this.form[key] = defaultValue;
        }
      }
    },
    formatSalaryOnBlur(event) {
      const value = event.target.value;
      this.form.salary = value;

      if (this.formatedSalary === '') {
        this.form.salary = this.defaultFormParams.salary;
      }

      this.updateFormattedSalary();
    },
    updateProgressBarWidth(value, min, max) {
      if (value === 0 || value === '') {
        return 0;
      }

      let percent = ((value - min) / (max - min)) * 100;
      percent = Math.min(percent, 100);

      return `${percent.toFixed(2)}%`;
    },
    handleSubmit() {
      this.$emit('submit');
    },
  },
};
</script>

<style lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;
@use '~styles/components/texts' as texts;

.calc-form {
  margin-top: 8rem;

  @include mixins.media(md) {
    max-width: 53rem;
    margin: 11rem auto 0;
  }

  @include mixins.media(lg) {
    max-width: 61.6rem;
    margin: 0;
  }

  &__row {
    margin-bottom: 3.4rem;
  }

  &__label {
    display: block;

    @include mixins.media(md) {
      @include mixins.font(1.7rem, 1.2);
    }

    @include mixins.media(xl) {
      @include mixins.font(2rem, 1.4);
    }
  }

  &__input-text {
    @include mixins.font(4rem);

    width: 100%;
    display: block;
    height: 4rem;
    padding: 0;
    -moz-appearance: textfield;
    background: transparent;
    letter-spacing: -0.6px;
    margin-bottom: 0.3rem;

    @include mixins.isFirefox {
      margin-bottom: 0;
    }

    @include mixins.media(md) {
      @include mixins.font(5.4rem);

      margin-bottom: 1rem;
      height: 4.5rem;
      letter-spacing: -0.81px;
    }

    &:focus {
      box-shadow: unset;
    }
  }

  &__error {
    @include mixins.font(1.6rem, 1.2);

    display: inline-block;
    margin: 4px 0;
    color: #f00;

    @include mixins.media(md) {
      @include mixins.font(2rem, 1.2);
    }
  }

  &__inputs {
    display: flex;
    flex-direction: column;
    margin-top: 1.6rem;

    @include mixins.media(md) {
      margin-top: 3rem;
    }
  }

  &__range {
    position: relative;
    display: flex;
    margin-top: 1rem;

    @include mixins.media(md) {
      margin-top: 1.2rem;
    }

    @include mixins.isFirefox {
      margin-top: 4px;

      @include mixins.media(md) {
        margin-top: 1.2rem;
      }
    }

    &::after {
      @include mixins.size(100%, 4px);

      position: absolute;
      z-index: -1;
      bottom: 20px;
      left: 0;
      background-color: #f1f1f1;
      content: '';

      @include mixins.isFirefox {
        bottom: 26px;

        @include mixins.media(md) {
          bottom: 32px;
        }
      }
    }

    &-input {
      position: relative;
      z-index: 10;
      width: 100%;
      -webkit-appearance: none;
      background: transparent;
      outline: none;
      padding: 10px 0;
      transform: translateY(-10px);

      @mixin track() {
        @include mixins.size(100%, 4px);

        box-sizing: border-box;
        background: transparent;
      }

      &::-webkit-slider-runnable-track {
        @include track();
      }

      &::-moz-range-track {
        @include track();
      }

      @mixin thumb() {
        @include mixins.size(24px);

        border: 8px solid #16bf54;
        margin-top: -10px;
        background: #fff;
        border-radius: 24px;
        box-shadow: 0 0 0 #fff;
        cursor: grab;
      }

      &::-webkit-slider-thumb {
        @include thumb();

        -webkit-appearance: none;
      }

      &::-moz-range-thumb {
        @include thumb();
        @include mixins.size(8px);
      }

      &--hidden-thumb {
        &::-moz-range-thumb {
          opacity: 0;
        }

        &::-webkit-slider-thumb {
          opacity: 0;
        }
      }
    }

    &-progress {
      position: absolute;
      top: 0;
      left: 0;
      height: 4px;
      background-color: #16bf54;
      border-radius: 4px;
      pointer-events: none;

      @include mixins.isFirefox {
        top: 10px;

        @include mixins.media(md) {
          top: 12px;
        }
      }
    }
  }

  &__button {
    width: 100%;
    cursor: pointer;

    @include mixins.media(md) {
      padding: 2.4rem 0;
    }

    @include mixins.media(lg) {
      @include mixins.font(2.2rem);
    }
  }
}
</style>
